<template>
  <div class="navbar">
    <div class="nav-warp">
      <div class="logo">
        <div class="home" @click="$router.push({ name: 'Home' })">
          <img src="@/assets/nav/logo.png" />
          <div class="title">
            <h3>农村产权交易中心</h3>
            <span>RURAL PROPERTY EXCHANGE CENTER</span>
          </div>
        </div>
        <div class="btn" @click="toApply">
          <img src="@/assets/nav/listing.png" />
          <span>我要挂牌</span>
        </div>
        <div class="btn" @click="toCertificateQuery">
          <img src="@/assets/nav/certificateQuery.png" />
          <span>鉴证书查询</span>
        </div>
      </div>
      <div class="search">
        <el-input placeholder="请输入您要找的关键词" v-model="search">
          <el-select v-model="select" slot="prepend" placeholder="请选择">
            <el-option label="交易项目" value="1"></el-option>
            <el-option label="项目公告" value="5"></el-option>
            <el-option label="成交公告" value="6"></el-option>
          </el-select>
          <el-button slot="append" @click="handleSearch">搜索</el-button>
          <!-- <template slot="append" @click="handleSearch">搜索</template> -->
        </el-input>
      </div>
    </div>
    <div class="nav-box">
      <div class="list">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="{ active: active == index }"
          @click="toSubnav(index)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="breadcrumb" v-if="active != 0 && noHeader">
      <header-img :list="headerList"></header-img>
    </div>
    <el-dialog
      width="640px"
      :show-close="false"
      :visible.sync="innerVisible"
    >
      <img class="right" src="@/assets/nav/left.png" />
      <img class="right left" src="@/assets/nav/right.png" />
      <div class="info">
        <div class="title">农特商城</div>
        <div>由广西捷算资产交易市场服务有限公司开发的扶贫商城系统</div>
        <div class="list">
          <div v-for="(item, index) in mallList" :key="index">{{ item }}</div>
        </div>
      </div>
      <div class="qr">
        <img class="mall" src="@/assets/nav/mall.png" />
        <div class="code">
          <vue-qr class="qrcode" :text="qr" :size="114"></vue-qr>
          <div>扫码进入商城</div>
        </div>
        <div class="type">支持公司福利补贴、微信、支付宝、银行卡等支付方式</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { sessionStore } from "@/utils/data-management";
import HeaderImg from "@/components/HeaderImg";
import { tableFilter } from "@/views/property-exchange-center/info-collection/tableFilter";
import VueQr from "vue-qr";
export default {
  props: {
    index: {
      type: Number,
    },
    noHeader: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    HeaderImg,
    VueQr,
  },
  data() {
    return {
      select: "1",
      search: "",
      list: [],
      active: 0,
      innerVisible: false,
      qr: "https://shop.baise.gjsc.info/#/home?platformId=394475091006345216",
      // qr: "http://shop.baise.gjsc.info/#/home?id=1321056857951805441",
      mallList: [],
    };
  },
  computed: {
    headerList() {
      let list = [];
      if (this.$route.query.index) {
        let index = this.$route.query.index;
        list = [
          { name: "首页", path: "/Home" },
          { name: this.list[index].name },
        ];
        if (this.$route.name == "announcementDetail") {
          list = [
            { name: "首页", path: "/Home" },
            {
              name: this.list[index].name,
              path: `/subnav/announcement-list?index=${index}`,
            },
            { name: "公告详情" },
          ];
        }
      }
      return list;
    },
  },
  created() {
    this.list = [
      { name: "首页", url: "Home" },
      { name: "交易项目", url: "exchangeProject" },
      { name: "竞价大厅", url: "exchangeProject" },
      { name: "农特商城", url: "Home" },
      { name: "政策法规", url: "announcementList" },
      { name: "项目公告", url: "announcementList" },
      { name: "成交公告", url: "announcementList" },
      { name: "抵押公告", url: "mortgageAnnouncement" },
      { name: "采购公告", url: "announcementList" },
      { name: "合作招商", url: "announcementList" },
    ];
    if (this.$route.query.index) {
      this.active = this.$route.query.index;
      this.search = this.$route.query.search;
    }
    this.mallList = [
      "扶贫产品",
      "商超",
      "餐饮",
      "智慧停车",
      "水电缴费",
      "学校缴费",
      "社保医保",
      "公积金",
      "燃气费",
      "有线电视",
      "公交卡充值",
      "物业费",
      "非税代收",
      "交通罚没",
      "...",
    ];
  },
  methods: {
    toSubnav(index) {
      if (index == 3) {
        this.innerVisible = true;
        return;
      }
      this.$router.push({
        name: this.list[index].url,
        query: {
          index: index,
        },
      });
      this.active = index;
    },
    toApply() {
      // 未登录
      if (!this.$store.state.token) {
        return this.$store.dispatch("getToken", "show");
      }
      // 未认证
      if (!this.$store.state.userInfo.personVertification) {
        return (this.$store.state.vertification = true);
      }
      if (this.$store.state.userInfo.userType === 1) {
        this.$api.user
          .getFarmersInfo({ phone: sessionStore.get("userInfo").phone })
          .then((res) => {
            if (res.code == 1000) {
              // tableFilter(res.data, true);
              // let status = this.$store.state.infoStatus;
              let status = res.data.approvalStatus
              // 信息采集通过完整，审核中
              if (status == 2 || status == 3) {
                this.$goTo("PropertyListingApplication");
              } else {
                this.$message.warning("请先完善信息采集");
                setTimeout(() => {
                  this.$goTo("infoCollection", { type: 4 });
                }, 500);
              }
            }
          });
      } else {
        this.$goTo("PropertyListingApplication");
      }
    },
    toCertificateQuery(){
      this.$goTo("certificateQuery");
    },
    handleSearch() {
      this.active = this.select;
      if (this.select == "1") {
        this.$router.push({
          name: "exchangeProject",
          query: {
            search: this.search,
            index: this.select,
          },
        });
      } else {
        this.$router.push({
          name: "announcementList",
          query: {
            search: this.search,
            index: this.select,
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.navbar {
  background: #fff;
  .nav-warp {
    width: 1200px;
    height: 150px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .search{
      padding-top: 50px;
    }
    .logo {
      display: flex;
      align-items: center;
      > div {
        display: flex;
        align-items: center;
      }
      .home {
        cursor: pointer;
      }
      img {
        width: 76px;
      }
      .title {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #394259;
        letter-spacing: 0.4px;
        line-height: 14px;
        margin-right: 30px;
        h3 {
          font-size: 36px;
          margin: 0 0 10px 0;
          letter-spacing: 0;
          line-height: 36px;
        }
      }
      .btn {
        width: 142px;
        height: 48px;
        justify-content: center;
        border: 1px solid #f65248;
        border-radius: 6px;
        opacity: 0.9;
        font-family: PingFangSC-Regular;
        font-size: 20px;
        color: #f65248;
        letter-spacing: 0;
        margin-right: 15px;
        img {
          width: 28px;
          height: 28px;
        }
      }
    }
    .search {
      .el-input-group {
        width: 455px;
        /deep/ .el-input-group__prepend {
          border-radius: 6px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          background: #f4f4f4;
          border-width: 0;
          .el-select {
            .el-input {
              width: 116px;
              .el-input__inner {
                font-size: 16px;
                color: #394259;
                border-right-color: #e6e6e6;
              }
              .el-icon-arrow-up:before {
                color: #394259;
                content: "\e78f";
              }
            }
          }
        }
        /deep/ .el-input__inner {
          line-height: 48px;
          height: 48px;
          background: #f4f4f4;
          border-width: 0;
          font-size: 16px;
          &::-webkit-input-placeholder {
            color: #a8aaae;
          }
          &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #a8aaae;
          }
          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: #a8aaae;
          }
          &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: #a8aaae;
          }
        }
        /deep/ .el-input-group__append {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #fff;
          letter-spacing: 0;
          line-height: 16px;
          background-image: linear-gradient(180deg, #e04357 0%, #bd202c 100%);
          border-radius: 0 6px 6px 0;
          border-width: 0;
          cursor: pointer;
        }
      }
    }
  }
  .nav-box {
    width: 100%;
    line-height: 48px;
    background-image: linear-gradient(137deg, #de4154 0%, #bb1e2a 100%);
    .list {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      div {
        flex: 1;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        cursor: pointer;
      }
      .active {
        font-family: PingFangSC-Semibold;
        color: #ffe39a;
        background: #b51725;
      }
    }
  }
  .breadcrumb {
    width: 100%;
    min-width: 1200px;
    background: #f8f9fb;
  }
  .el-dialog__wrapper {
    /deep/ .el-dialog {
      border-radius: 6px;
    }
    /deep/ .el-dialog__header {
      display: none;
    }
    /deep/ .el-dialog__body {
      position: relative;
      padding: 0;
      .right {
        width: 160px;
        position: absolute;
        top: 0;
        right: 0;
      }
      .left {
        top: auto;
        right: auto;
        bottom: 0;
        left: -1px;
      }
      .info {
        padding: 50px 0 30px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #394259;
        letter-spacing: 0;
        text-align: center;
        .title {
          font-family: YouSheBiaoTiHei;
          font-size: 56px;
          font-style: italic;
          color: #4262c0;
          line-height: 56px;
          margin-bottom: 12px;
        }
        .list {
          width: 500px;
          margin: 28px auto 0;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          div {
            width: 92px;
            line-height: 30px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #4262c0;
            background: rgba($color: #c5e0ff, $alpha: 0.3);
            border-radius: 4px;
            margin-bottom: 10px;
          }
        }
      }
      .qr {
        position: relative;
        text-align: center;
        padding-bottom: 50px;
        .mall {
          width: 330px;
          height: 212px;
          margin: 0 0 56px 180px;
        }
        .code {
          width: 188px;
          height: 188px;
          text-align: center;
          background: url("~@/assets/nav/code.png");
          background-size: 100% 100%;
          position: absolute;
          top: 50px;
          left: 130px;
          .qrcode {
            margin: 15px auto 0;
          }
          div {
            font-size: 14px;
            color: #fff;
          }
        }
        .type {
          text-align: center;
          font-size: 14px;
          color: #394259;
        }
      }
    }
  }
}
</style>
